import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import SignInPage from './containers/auth/SignIn';
import ForgetPasswordPage from './containers/auth/ForgetPassword';
import ResetPasswordPage from './containers/auth/ResetPassword';
import LogoutPage from './components/auth/Logout';
import NotFound404 from './components/404';
import { prefixPath } from './helpers';
import useLocale from './hooks/useLocale';

const Dashboard = React.lazy(() => import('./components/Dashboard'));

const NoDashboard = React.lazy(() => import('./components/NoDashboard'))
NoDashboard.displayName = 'NoDashboard';

const BackOffice = React.lazy(() => import('./components/BackOffice'))
BackOffice.displayName = 'BackOffice';

const paths = {
  dashboard: prefixPath('/dashboard', ':locale'),
  login: prefixPath('/login', ':locale'),
  forget: prefixPath('/forget', ':locale'),
  reset: prefixPath('/reset', ':locale'),
  logout: prefixPath('/logout', ':locale'),
  outside: prefixPath('/outside', ':locale'),
  backoffice: prefixPath('/backoffice', ':locale')
};

function Routes() {
  const { lang } = useLocale();
  return (
    <Switch>
      <Route
        path={'/:locale?'}
        exact={true}
        component={() => <Redirect to={`/${lang}/dashboard`} />}
      />

      <Route path={paths.dashboard} component={Dashboard} />
      <Route path={paths.login} component={SignInPage} />
      <Route path={paths.forget} component={ForgetPasswordPage} exact={true} />
      <Route path={paths.reset} component={ResetPasswordPage} exact={true} />
      <Route path={paths.logout} component={LogoutPage} exact={true} />
      <Route path={paths.outside} component={NoDashboard} />
      <Route path={paths.backoffice} component={BackOffice} />
      <Route path={'*'} component={NotFound404} />
    </Switch>
  );
}

export default React.memo(Routes);
